import { type Ref } from "vue";

import {
  useBrowserStore,
  type SyncedState,
} from "@/composables/useBrowserStore";
import { type UseProfile } from "@/composables/useProfile";

/**
 * Document "wide mode" preference, persisted to local storage per account.
 *
 * This used to be bundled into the planner's `UseLocalSettings` singleton even
 * though it has nothing to do with the planner; it now lives on its own. The
 * storage key (`document:isWide`) is kept unchanged to preserve existing
 * preferences.
 *
 * The caller owns the returned state (`releaser.add(useWideDocument(...))`).
 */
export const useWideDocument = (
  profile: Ref<UseProfile>
): SyncedState<boolean> => {
  const { syncState } = useBrowserStore(profile.value.user.accountId);
  return syncState<boolean>("document:isWide", false);
};
